export default "__VITE_ASSET__B82Qf2l7__"